<template>
  <div class="index">
    <router-view></router-view>
    <div>
      <van-tabbar
        v-model="active"
        :fixed="true"
        class="active_tab"
        active-color="#ff9900"
        inactive-color="#333"
      >
        <van-tabbar-item icon="wap-home" to="/home">首页</van-tabbar-item>
        <van-tabbar-item icon="qr" to="/category">分类</van-tabbar-item>
        <van-tabbar-item icon="search" to="/search">搜索</van-tabbar-item>
        <van-tabbar-item icon="cart-o" :info="this.$store.getters.getAllCount" to="/cart">购物车</van-tabbar-item>
        <van-tabbar-item icon="contact" to="main">我的</van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      active: 0,
    };
  },
  created() {
    this.changeTabBarActive();
    // console.log(this.$store.getters.getAllCount);
    // console.log(localStorage.getItem('cartList'))
  },
  updated() {
    this.changeTabBarActive();
  },
  methods: {
    changeTabBarActive() {
      this.nowPath = this.$route.path;
      switch (this.nowPath) {
        case "/home":
          this.active = 0;
          break;
        case "/category":
          this.active = 1;
          break;
        case "/search":
          this.active = 2;
          break;
        case "/cart":
          this.active = 3;
          break;
        case "/main":
          this.active = 4;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.index {
  width: 100%;
  height: 100%;
  padding-bottom: 104px;
}
.active_tab {
  height: 104px;
  span {
    font-size: 20px;
  }
}
.tab-icon {
  width: 5.333vw;
  height: 5.333vw;
  img {
    width: 100%;
    height: 100%;
  }
}

</style>